import getMarkdocModel from "../../getters/markdocModel";

export const mermaid = getMarkdocModel("Mermaid");
